import type { PropsWithChildren } from "react";

import { ErrorBoundary } from "react-error-boundary";

import Sentry from "@similarweb/sentry-logger";

import { FeedErrorState } from "./state-fabric/FeedErrorState";
import type { AlertTabId } from "./tabs/config";
import type { AlertViewMode } from "./tabs/viewModeConfig";

type ErrorInfo = {
    componentStack: string;
};

interface IFeedErrorBoundaryProps {
    alertType: AlertTabId;
    viewMode?: AlertViewMode;
}

export const AlertsErrorBoundary = ({
    children,
    alertType,
    viewMode = "feed",
}: PropsWithChildren<IFeedErrorBoundaryProps>) => {
    const handleError = (error: Error, info: ErrorInfo): void => {
        Sentry.errorTracker({
            message: `[Activation Alerts] ${viewMode} error in ${alertType}`,
            e: error,
            level: "error",
            params: {
                tags: {
                    solution: "activation-alerts",
                    // eslint-disable-next-line @typescript-eslint/naming-convention -- ErrorType tag is used for Sentry alerts
                    ErrorType: "AlertsErrorBoundary",
                    alertType,
                    viewMode,
                },
                extra: {
                    componentStack: info.componentStack,
                },
            },
        });
    };

    return (
        <ErrorBoundary
            FallbackComponent={FeedErrorState}
            onError={handleError}
        >
            {children}
        </ErrorBoundary>
    );
};
